// The modules the app ships with, in rail order. App.tsx provides the set
// through ScreensContext; the chrome reads it and never names one by hand.

import type { ModuleScreens } from "./components/chrome/screens";
import { billingScreens } from "./modules/billing/screens";
import { intakeScreens } from "./modules/intake/screens";

export const MODULE_SCREENS: ModuleScreens[] = [billingScreens, intakeScreens];
